import { render, staticRenderFns } from "./CoreChatClient.vue?vue&type=template&id=cb864058&"
import script from "./CoreChatClient.vue?vue&type=script&lang=js&"
export * from "./CoreChatClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports